<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysQAAndOfferGenerationTotal',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            width: {type:Number, default: 25},
        },
        data() {
            return {
                main_icon: 'fa-light fa-file-check',
                title: 'Today\'s QA/Offer Total',
                load_url: '/dashboards/TotalQA/',
                icon_data: [
                    {
//                        name: 'QA Total',
                        name: 'QA',
                        text_color: '#2A9D8F',
                    },
                    {
//                        name: 'Offers Generated Total',
                        name: 'Offers Generated',
                        text_color: '#F4A261',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>